import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { RequireAuth } from "./components/RequireAuth";
import { LoginPage } from "./pages/Login";
import { AuthCallbackPage } from "./pages/AuthCallback";
import { Dashboard } from "./pages/Dashboard";
import { AndesQueue } from "./pages/AndesQueue";
import { UsersList } from "./pages/Users";
import { SubscribersList } from "./pages/subscribers/List";
import { SubscribersCreate } from "./pages/subscribers/Create";
import { SubscriberDetail } from "./pages/subscribers/Detail";
import { UtilitiesCsr } from "./pages/utilities/Csr";
import { UtilitiesPfx } from "./pages/utilities/Pfx";
import { UtilitiesP12 } from "./pages/utilities/P12";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<UsersList />} />
        <Route path="subscribers" element={<SubscribersList />} />
        <Route path="subscribers/new" element={<SubscribersCreate />} />
        <Route path="subscribers/:id" element={<SubscriberDetail />} />
        <Route path="subscribers/:id/:tab" element={<SubscriberDetail />} />
        <Route path="andes-queue" element={<AndesQueue />} />
        <Route path="utilities/csr" element={<UtilitiesCsr />} />
        <Route path="utilities/pfx" element={<UtilitiesPfx />} />
        <Route path="utilities/p12" element={<UtilitiesP12 />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
